import { useState } from 'react';
import { CustomTemplate } from 'types/template';
import WizardButtonWrapper from '../../Wizard/WizardButtonWrapper';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

interface Props {
  onModalClose: () => void;
  handleTeamTemplateCreation: (template: CustomTemplate) => void;
  selectedTemplate: CustomTemplate;
}

export default function ConfigureTeam({
  onModalClose,
  handleTeamTemplateCreation,
  selectedTemplate,
}: Props) {
  const [templateName, setTemplateName] = useState(
    selectedTemplate?.label ?? ''
  );
  const [description, setDescription] = useState(
    selectedTemplate?.description ?? ''
  );

  return (
    <div className="w-100 d-flex flex-column align-items-start">
      <div className="w-100 mb-4">
        <label className="form-label">
          Template Name <span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Name the team to capture its core purpose. e.g., 'Quick Response Coordination'"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
        />
      </div>
      <div className="w-100 mb-4">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g., 'Rapid incident management and response team workspace.'"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <WizardButtonWrapper onModalClose={onModalClose}>
        <div className="d-flex">
          <StylishNewButton
            className="button--primary ms-2"
            onClick={() =>
              handleTeamTemplateCreation({
                ...selectedTemplate,
                label: templateName,
                description,
              })
            }
            disabled={!templateName}
          >
            Next
          </StylishNewButton>
        </div>
      </WizardButtonWrapper>
    </div>
  );
}
